import React, { cloneElement, ReactElement } from 'react';
import { Link, useHistory, LinkProps } from 'react-router-dom';

interface ActiveLinkProps extends LinkProps {
  children: ReactElement;
  shouldMatchExactHref?: boolean;
}

export const ActiveLink: React.FC<ActiveLinkProps> = ({
  children,
  shouldMatchExactHref = false,
  ...props
}) => {
  const { location } = useHistory();
  let isActive = false;

  if (shouldMatchExactHref && location.pathname === props.to) {
    isActive = true;
  }

  if (!shouldMatchExactHref && location.pathname.startsWith(String(props.to))) {
    isActive = true;
  }

  return (
    <Link {...props}>
      {cloneElement(children, {
        color: isActive ? 'purple.400' : 'gray.700',
      })}
    </Link>
  );
};
